export default function initMainWarehouseStocks() {
    return {
        async showModalMainWarehouseStock(event, id) {
            // event.preventDefault();
            const url = `/api/stocks/main-warehouse/${id}/show-data-modal`;
            
            // Use the global ERPHelpers function for loading modal content
            await ERPHelpers.loadModalContent('addEditModal', url);
        },
    }
}
